import React from "react";
import {
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  SelectionMode,
} from "@fluentui/react/lib/DetailsList";
import { TrialRequest } from "./AdminStore";

interface TrialRequestListProps {
  requests: TrialRequest[];
  onSelect: (request: TrialRequest) => void;
}

export const TrialRequestList: React.FunctionComponent<TrialRequestListProps> = ({
  requests,
  onSelect,
}) => {
  const columns: IColumn[] = [
    {
      key: "createdAt",
      name: "Date",
      fieldName: "createdAt",
      minWidth: 160,
      maxWidth: 180,
      onRender: (item: TrialRequest) => new Date(item.createdAt).toLocaleString(),
    },
    {
      key: "name",
      name: "Name",
      minWidth: 140,
      maxWidth: 180,
      onRender: (item: TrialRequest) => `${item.firstName} ${item.lastName}`,
    },
    {
      key: "requesterEmail",
      name: "Email",
      fieldName: "requesterEmail",
      minWidth: 180,
      maxWidth: 240,
    },
    {
      key: "company",
      name: "Company",
      fieldName: "company",
      minWidth: 120,
      maxWidth: 180,
    },
    {
      key: "isDuplicate",
      name: "Status",
      minWidth: 100,
      maxWidth: 120,
      onRender: (item: TrialRequest) => (item.isDuplicate ? "Duplicate" : "New"),
    },
  ];

  return (
    <DetailsList
      items={requests}
      columns={columns}
      setKey="trial-requests"
      layoutMode={DetailsListLayoutMode.justified}
      selectionMode={SelectionMode.none}
      onItemInvoked={(item) => onSelect(item as TrialRequest)}
    />
  );
};
